import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../service.css";

export const Luggage = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div className="tj-inner-banner">
        <div className="container">
          <h2>Lugage Policy</h2>
        </div>
      </div>

      <div className="tj-breadcrumb">
        <div className="container">
          <ul className="breadcrumb-list">
            <li>
              <Link to="/">Home</Link>
            </li>
            <li className="active">Lugage Policy</li>
          </ul>
        </div>
      </div>
      <div className="container" style={{ paddingTop: "90px" }}>
        <div style={{ padding: "30px", display: "flex" }}></div>

        <h1 className="farex-h1" style={{ textAlign: "center" }}>
          Luggage Policy on a Hireme
        </h1>

        <div id="section-43540" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <p>
              Each Hireme has plenty of space for your luggage. To make your trip
              as pleasant and safe as possible, there are some regulations to
              regard.
            </p>
          </div>
        </div>

        <div id="section-43543" style={{ clear: "both" }}>
          <h2 className="farex-h2 farex-h2--section-header">
            Your Hireme ticket includes the FREE transportation of:
          </h2>
          <div className="farex-grid">
            <article className="farex-col-12 farex-col-12-sm image-text-vertical-box">
              {/*    <figure>
                <div className="image-with-copyright-info--container">
                  <img
                    src="https://cdn-cf.cms.Farex.com/drupal-assets/styles/20px/s3/2021-05/Carry-On%20Bag_0.png"
                    className="image-text-vertical-img"
                    alt="Farex Carry-On Bag: 7 kg; 30 cm x 18 cm x 42 cm"
                    height="258px"
                    width="360px"
                    data-lazyload="https://cdn-cf.cms.Farex.com/drupal-assets/styles/image_text_vertical/s3/2021-05/Carry-On%20Bag_0.png 284w, https://cdn-cf.cms.Farex.com/drupal-assets/styles/image_text_vertical_2x/s3/2021-05/Carry-On%20Bag_0.png 568w"
                    sizes="(min-width: 600px) 284px, 100vw"
                  />
                </div>
              </figure> */}

              <h3 className="farex-h3">1x Carry-On Bag</h3>
              <div className="farex-text image-text-vertical-body">
                <p>
                For safety reasons, please stow your carry-on bag securely in the designated storage area or keep it with you without obstructing the seating space.

                </p>
                <p>
                  <em>
                    Note: Carry valuables (identification, electronics, etc.)
                    with you in your carry-on bag.
                  </em>
                </p>
              </div>
            </article>

            {/* <article className="farex-col-12 farex-col-6-sm image-text-vertical-box"> */}
              {/*      <figure>
                <div className="image-with-copyright-info--container">
                  <img
                    src="https://cdn-cf.cms.Farex.com/drupal-assets/styles/20px/s3/2021-05/Checked%20Bag_0.png"
                    className="image-text-vertical-img"
                    alt="Farex Checked Bag: 20 kg; 50 cm x 30 cm x 80 cm"
                    height="258px"
                    width="360px"
                    data-lazyload="https://cdn-cf.cms.Farex.com/drupal-assets/styles/image_text_vertical/s3/2021-05/Checked%20Bag_0.png 284w, https://cdn-cf.cms.Farex.com/drupal-assets/styles/image_text_vertical_2x/s3/2021-05/Checked%20Bag_0.png 568w"
                    sizes="(min-width: 600px) 284px, 100vw"
                  />
                </div>
              </figure> */}

              {/* <h3 className="farex-h3">1x Checked Bag</h3>
              <div className="farex-text image-text-vertical-body">
                <p>
                  Your checked bag is to be stowed in the luggage compartment
                  before you enter the bus. Your bus driver is happy to help you
                  with that. We recommend labeling your bag with your name and
                  address. In some cases Farex will hand out bag tags.
                </p>
              </div> */}
            {/* </article> */}
          </div>
        </div>

        <div id="section-43544" style={{ clear: "both" }}>
          <div
            className="farex-text basic-page-paragraph-container"
            style={{ overflowY: "auto" }}
          >
            <p>
              We strongly recommend clearly labeling all luggage with your name,
              address, and telephone number.
            </p>
            <h4>
              <br />
              Lost your bag? Please fill out our{" "}
              <Link to={"/contact-us"}>Lost &amp; Found</Link> form.
            </h4>
          </div>
        </div>

        {/* <div id="section-43556" style={{ clear: "both" }}>
          <div className="basic-page-paragraph-container">
            <h2 className="farex-h2 farex-h2--section-header">
              Carrying more items?
            </h2>

            <details className="farex-accordion" id="section-43546">
              <summary
                className="farex-accordion__title"
                role="button"
                tabindex="0"
                aria-expanded="false"
              >
                Additional Luggage
              </summary>
              <article className="farex-accordion__content farex-space-4-top">
                <div id="section-43545">
                  <div
                    className="basic-page-paragraph-container"
                    style={{ clear: "both" }}
                  >
                    <div className="farex-grid image-text-horizontal-left"> */}
                      {/* <div className="farex-col-12 farex-col-6-md image-text-horizontal-image-wrapper-left">
                        {" "}
                        <figure>
                          <div className="image-with-copyright-info--container">
                            <img
                              src="https://cdn-cf.cms.Farex.com/drupal-assets/styles/20px/s3/2021-05/Additional%20Baggage_0.png"
                              className="image-text-horizontal-image"
                              alt="Farex Additional Luggage: 20 kg; 50 cm x 30 cm x 80 cm"
                              height="258px"
                              width="360px"
                              data-lazyload="https://cdn-cf.cms.Farex.com/drupal-assets/styles/image_text_horizontal/s3/2021-05/Additional%20Baggage_0.png 360w, https://cdn-cf.cms.Farex.com/drupal-assets/styles/image_text_horizontal_2x/s3/2021-05/Additional%20Baggage_0.png 720w"
                              sizes="(min-width: 600px) 360px, 100vw"
                            />
                          </div>
                        </figure>{" "}
                       
                      </div> */}

                      {/* <div className="farex-col-12 farex-col-12-md">
                        <div className="farex-text image-text-horizontal-text">
                          <p>
                            <strong>
                              How much additional luggage can I take with me?
                            </strong>
                          </p>
                          <p>
                            You are allowed to bring 1 additional luggage per
                            passenger.
                          </p>
                          <p>
                            <strong>
                              How much does additional luggage cost?
                            </strong>
                          </p>
                          <p>
                            For more information, please see the{" "}
                            <Link to={"/luggage-price-list"}>price list</Link>.
                          </p> */}
                          {/* <p>
                            <strong>How do I book additional luggage?</strong>
                          </p>
                          <p>
                            Online after completed ticket purchase via{" "}
                            <a href="https://shop.Farex.in/rebooking/login">
                              Manage My Booking
                            </a>
                          </p> */}
                          {/* <p>
                            <strong>Special Note</strong>
                          </p>
                          <p>
                            There is limited space for additional luggage on the
                            bus. We recommend booking your additional luggage as
                            early as possible.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </details> */}

            {/* <details className="farex-accordion" id="section-43551">
              <summary
                className="farex-accordion__title"
                role="button"
                tabindex="0"
                aria-expanded="false"
              >
                Musical Instruments
              </summary>
              <article className="farex-accordion__content farex-space-4-top">
                <div id="section-43549">
                  <div
                    className="basic-page-paragraph-container"
                    style={{ clear: "both" }}
                  >
                    <div className="farex-grid image-text-horizontal-left"> */}
                      {/*<div className="farex-col-12 farex-col-6-md image-text-horizontal-image-wrapper-left">
                            <figure>
                          <div className="image-with-copyright-info--container">
                            <img
                              src="https://cdn-cf.cms.Farex.com/drupal-assets/styles/20px/s3/2021-05/Musical%20Instruments%20-%20small.png"
                              className="image-text-horizontal-image"
                              alt="Farex Small Instruments: 7 kg; 30 cm x 18 cm x 42 cm "
                              height="258px"
                              width="360px"
                              data-lazyload="https://cdn-cf.cms.Farex.com/drupal-assets/styles/image_text_horizontal/s3/2021-05/Musical%20Instruments%20-%20small.png 360w, https://cdn-cf.cms.Farex.com/drupal-assets/styles/image_text_horizontal_2x/s3/2021-05/Musical%20Instruments%20-%20small.png 720w"
                              sizes="(min-width: 600px) 360px, 100vw"
                            />
                          </div>
                        </figure> 
                      </div>*/}

                      {/* <div className="farex-col-12 farex-col-12-md">
                        <div className="farex-text image-text-horizontal-text">
                          <h3>Small Instruments</h3>

                          <p>
                            <strong>
                              How many small instruments&nbsp;can I take with
                              me?
                            </strong>
                          </p>

                          <p>
                            You can bring 1 small instrument per passenger
                            instead of your carry-on bag.
                          </p>

                          <p>
                            <strong>How much does it&nbsp;cost?</strong>
                          </p>

                          <p>1 small instrument is free of charge.</p>

                          <p>
                            <strong>How do I book additional luggage?</strong>
                          </p>

                          <p>
                            You do not need to book a small instrument in
                            advance.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}

                {/* <div id="section-43550">
                  <div
                    className="basic-page-paragraph-container"
                    style={{ clear: "both" }} */}
                  {/* >
                    <div className="farex-grid image-text-horizontal-left"> */}
                      {/* <div className="farex-col-12 farex-col-6-md image-text-horizontal-image-wrapper-left">
                         <figure>
                          <div className="image-with-copyright-info--container">
                            <img
                              src="https://cdn-cf.cms.Farex.com/drupal-assets/styles/20px/s3/2021-05/Musical%20Instruments%20-%20big.png"
                              className="image-text-horizontal-image"
                              alt="Farex Large Instruments: 30 kg; 48 cm x 35 cm x 135 cm "
                              height="258px"
                              width="360px"
                              data-lazyload="https://cdn-cf.cms.Farex.com/drupal-assets/styles/image_text_horizontal/s3/2021-05/Musical%20Instruments%20-%20big.png 360w, https://cdn-cf.cms.Farex.com/drupal-assets/styles/image_text_horizontal_2x/s3/2021-05/Musical%20Instruments%20-%20big.png 720w"
                              sizes="(min-width: 600px) 360px, 100vw"
                            />
                          </div>
                        </figure> 
                      </div>*/}

                      {/* <div className="farex-col-12 farex-col-12-md">
                        <div className="farex-text image-text-horizontal-text">
                          <h3>Large Instrument</h3>
                          <p>
                            <strong>
                              How many large instruments&nbsp;can I take with
                              me?
                            </strong>
                          </p>
                          <p>
                            As large instruments are considered special luggage,
                            you can bring 1 large instrument per passenger.
                          </p>
                          <p>
                            <strong>How much does it&nbsp;cost?</strong>
                          </p>
                          <p>
                            The fee depends on the booking method. For more
                            information, please see the{" "}
                            <Link to={"/luggage-price-list"}>price list</Link>.
                          </p>

                          <p>
                            <strong>Special Note</strong>
                          </p>
                          <p>
                            We recommend bringing your instrument in a hard case
                            to avoid potential damages. Since there is limited
                            space for special luggage on the bus, we recommend
                            booking your instrument as early as possible.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </details> */}
{/* 
            <details className="farex-accordion" id="section-43553">
              <summary
                className="farex-accordion__title"
                role="button"
                tabindex="0"
                aria-expanded="false"
              >
                Wheelchairs / Walking Aids
              </summary>
              <article className="farex-accordion__content farex-space-4-top">
                <div id="section-43552">
                  <div
                    className="basic-page-paragraph-container"
                    style={{ clear: "both" }}
                  >
                    <div className="farex-grid image-text-horizontal-left"> */}
                      {/*<div className="farex-col-12 farex-col-6-md image-text-horizontal-image-wrapper-left">
                         <figure>
                          <div className="image-with-copyright-info--container">
                            <img
                              src="https://cdn-cf.cms.Farex.com/drupal-assets/styles/20px/s3/2021-05/Wheelchairs.png"
                              className="image-text-horizontal-image"
                              alt=""
                              height="258px"
                              width="360px"
                              data-lazyload="https://cdn-cf.cms.Farex.com/drupal-assets/styles/image_text_horizontal/s3/2021-05/Wheelchairs.png 360w, https://cdn-cf.cms.Farex.com/drupal-assets/styles/image_text_horizontal_2x/s3/2021-05/Wheelchairs.png 720w"
                              sizes="(min-width: 600px) 360px, 100vw"
                            />
                          </div>
                        </figure> 
                      </div>*/}

                      {/* <div className="farex-col-12 farex-col-12-md">
                        <div className="farex-text image-text-horizontal-text">
                          <p>
                            If you are restricted in your mobility and are able
                            to get on-and-off on your own or with the help of a
                            companion, you can travel with all Farex lines. Your
                            walking aid or wheelchair will be transported for
                            free. Your wheelchair must be foldable, so that the
                            driver can stow it in the luggage compartment of the
                            bus. Please submit a{" "}
                            <Link to={"/contact-us"}>contact form</Link> at
                            least 36 hours before your departure.
                          </p>
                          <p>
                            In some of our buses, there is also space for
                            passengers to board the bus with their wheelchairs.
                            For more information, please{" "}
                            <Link to={"/contact-us"}>submit a request</Link> 7
                            days before departure.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </details>

            <details className="farex-accordion" id="section-43555">
              <summary
                className="farex-accordion__title"
                role="button"
                tabindex="0"
                aria-expanded="false"
              >
                Animals
              </summary>
              <article className="farex-accordion__content farex-space-4-top">
                <div id="section-43554">
                  <div
                    className="basic-page-paragraph-container"
                    style={{ clear: "both" }}
                  >
                    <div className="farex-grid image-text-horizontal-left"> */}
                      {/* <div className="farex-col-12 farex-col-6-md image-text-horizontal-image-wrapper-left">
                           <figure>
                          <div className="image-with-copyright-info--container">
                            <img
                              src="https://cdn-cf.cms.Farex.com/drupal-assets/styles/20px/s3/2021-05/Pets.png"
                              className="image-text-horizontal-image"
                              alt=""
                              height="258px"
                              width="360px"
                              data-lazyload="https://cdn-cf.cms.Farex.com/drupal-assets/styles/image_text_horizontal/s3/2021-05/Pets.png 360w, https://cdn-cf.cms.Farex.com/drupal-assets/styles/image_text_horizontal_2x/s3/2021-05/Pets.png 720w"
                              sizes="(min-width: 600px) 360px, 100vw"
                            />
                          </div>
                        </figure> 
                      </div>*/}

                      {/* <div className="farex-col-12 farex-col-12-md">
                        <div className="farex-text image-text-horizontal-text">
                          <h3>
                            Am I allowed to bring my pet on board a&nbsp;Farex?
                          </h3>

                          <p>
                            No, we do not transport animals on our buses, with
                            the exception of service animals for persons with
                            disabilities.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </article>
            </details> */}
          {/* </div> */}
        {/* </div> */}
      </div>
    </div>
  );
};
